module.exports = __webpack_public_path__ + "img/oee.5af92413.png";